import React from 'react'

import { FEATURES_TYPE } from '@constants'
import AppLayout from 'Layout'
import { Navigate } from 'react-router-dom'
import { ADMIN_ROUTES } from '@constants/routes'
import GlobalExecutionAdminPage from 'Pages/Admin/GlobalExecution'
import OfficeMappingAdminPage from 'Pages/Admin/OfficeMapping'
import UsersControlAdminPage from 'Pages/Admin/Users'
import AdminDataStudio from 'Pages/Admin/DataStudio'
import AdminDataStudioSingle from 'Pages/Admin/DataStudioSingle'
import ExportConnectionsAdminPage from 'Pages/Admin/ExportConnections'
import ProvidersSuppliersMappingAdminPage from 'Pages/Admin/ProvidersSuppliersMapping'
import GroupedExportsPage from 'Pages/Admin/GroupedExports'
import ReportsHandlerAdminPage from 'Pages/Admin/ReportsHandler'
import AdminMappingPage from 'Pages/Admin/AdminMapping'
import CustomMappingPage from 'Pages/User/CustomMapping'
import RunningScrappersAdminPage from './GlobalExecution/Scrapers'


export const AdminRoutes = userData => ({
  id: FEATURES_TYPE.ADMIN,
  path: ADMIN_ROUTES.PATH,
  title: ADMIN_ROUTES.TITLE,
  icon: 'table-tree',
  element: <AppLayout/>,
  children: [
    {
      element: <Navigate to={ADMIN_ROUTES.GLOBAL_EXECUTION_PATH} replace/>,
      index: true,
    },
    {
      path: ADMIN_ROUTES.GLOBAL_EXECUTION_PATH,
      title: ADMIN_ROUTES.GLOBAL_EXECUTION_SUBTITLE,
      element: <GlobalExecutionAdminPage/>,
    },
    {
      path: ADMIN_ROUTES.CUSTOM_OFFICE_PATH,
      title: ADMIN_ROUTES.CUSTOM_OFFICE_SUBTITLE,
      element: <OfficeMappingAdminPage/>,
    },
    {
      path: ADMIN_ROUTES.USER_CONFIG_PATH,
      title: ADMIN_ROUTES.USER_CONFIG_SUBTITLE,
      element: <UsersControlAdminPage/>,
    },
    {
      path: ADMIN_ROUTES.DATA_STUDIO_PATH,
      title: ADMIN_ROUTES.DATA_STUDIO_SUBTITLE,
      element: <AdminDataStudio/>,
    },
    {
      path: ADMIN_ROUTES.DATA_STUDIO_SINGLE_PATH,
      title: ADMIN_ROUTES.DATA_STUDIO_SINGLE_SUBTITLE,
      element: <AdminDataStudioSingle/>,
    },
    {
      path: ADMIN_ROUTES.EXPORT_CONNECTIONS_PATH,
      title: ADMIN_ROUTES.EXPORT_CONNECTIONS_SUBTITLE,
      element: <ExportConnectionsAdminPage/>,
    },
    {
      path: ADMIN_ROUTES.PROVIDERS_WEB_SUPPLIERS_MAPPING_PATH,
      title: ADMIN_ROUTES.PROVIDERS_WEB_SUPPLIERS_MAPPING_SUBTITLE,
      element: <ProvidersSuppliersMappingAdminPage/>,
    },
    {
      path: ADMIN_ROUTES.GROUPED_EXPORTS_PATH,
      title: ADMIN_ROUTES.GROUPED_EXPORTS_SUBTITLE,
      element: <GroupedExportsPage isExtra={false}/>,
    },
    {
      path: ADMIN_ROUTES.GROUPED_EXTRA_EXPORTS_PATH,
      title: ADMIN_ROUTES.GROUPED_EXTRA_EXPORTS_SUBTITLE,
      element: <GroupedExportsPage isExtra={true}/>,
    },
    {
      path: ADMIN_ROUTES.REPORT_HANDLER_PATH,
      title: ADMIN_ROUTES.REPORT_HANDLER_SUBTITLE,
      element: <ReportsHandlerAdminPage/>,
    },
    // {
    //   path: ADMIN_ROUTES.ADMIN_MAPPING_PATH,
    //   title: ADMIN_ROUTES.ADMIN_MAPPING_SUBTITLE,
    //   element: <AdminMappingPage/>
    // }
  ]
})